import { useState } from 'react';

import { HorizontalMenuTabs } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { UserProfileResponse } from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { Typography, Theme, SxProps, Box, Divider, Stack } from '@mui/material';

import { ProfileVideoView } from './ProfileVideoView';

const PUBLIC_PROFILE_STRINGS = appStrings.modules.profile.public;

type PublicProfileSnapshotProps = Readonly<{
  publicProfile?: UserProfileResponse;
}>;

const tabOptions = ['View all', 'Career', 'Academic', 'Life'];

export const PublicProfileStory = ({ publicProfile }: PublicProfileSnapshotProps) => {
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const filteredDocuments = publicProfile?.profile?.documentsStoryVideos?.filter((document) => {
    // if the selected tab is "View all", return all documents
    if (selectedTab === 0) {
      return true;
    }

    return document.question_id === tabOptions[selectedTab].toLowerCase();
  });

  return (
    <Stack spacing={3} sx={containerSx}>
      <Divider />
      <Box sx={headerSx}>
        <Typography variant="display-sm-medium">
          {publicProfile?.profile?.publicProfile?.first_name}'s {PUBLIC_PROFILE_STRINGS.story}
        </Typography>

        <HorizontalMenuTabs
          tabs={tabOptions}
          value={selectedTab}
          setValue={(value) => setSelectedTab(value)}
          variant="filter"
        />
      </Box>

      <Box sx={documentsContainerSx}>
        <ProfileVideoView
          storyDocuments={filteredDocuments || []}
          showDelete={false}
          fixedWidth={false}
          user={publicProfile?.profile?.publicProfile}
        />
      </Box>
    </Stack>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  marginTop: backrs.spacing['spacing-4xl'],
  paddingX: {
    xs: backrs.spacing['spacing-xl'],
    sm: backrs.spacing['spacing-4xl'],
  },
  paddingBottom: backrs.spacing['spacing-4xl'],
  maxWidth: '1216px',
});

const headerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: { xs: backrs.spacing['spacing-2xl'], md: backrs.spacing['spacing-md'] },
});

const documentsContainerSx: SxProps<Theme> = ({ backrs }) => ({
  gap: backrs.spacing['spacing-lg'],
  display: 'flex',
  flexDirection: 'column',
});
